import axiosInstance from '../../../utils/axiosConfig'
import { mobileBackendUrl } from '../../../env'
import type { TaxHarvestingRecommendationResponse } from '../types/recommendation.types'
import type { HarvestingPlanType } from '../types/summary.types'

export type RecommendationQueryParams = {
  isin: string
  amount: number
  harvestType: HarvestingPlanType
  possibleFolioTaxHarvestingTypes?: HarvestingPlanType[]
}

export async function fetchTaxHarvestingRecommendation(
  params: RecommendationQueryParams
): Promise<TaxHarvestingRecommendationResponse> {
  const { isin, amount, harvestType, possibleFolioTaxHarvestingTypes } = params
  const searchParams = new URLSearchParams({
    isin,
    amount: String(amount),
    harvestType
  })
  if (Array.isArray(possibleFolioTaxHarvestingTypes) && possibleFolioTaxHarvestingTypes.length > 0) {
    searchParams.set('folioTaxHarvestingTypes', possibleFolioTaxHarvestingTypes.join(','))
  }
  const response = await axiosInstance.get<TaxHarvestingRecommendationResponse>(
    `${mobileBackendUrl}/v2/tax-harvesting/folio-withdraw-details?${searchParams.toString()}`
  )
  if (!response?.data) {
    throw new Error('Failed to fetch tax harvesting recommendation')
  }
  return response.data as TaxHarvestingRecommendationResponse
}
